import ConfirmOwnership from './ConfirmOwnership';

export default ConfirmOwnership;
